if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.init();
		}

		init(){
			this.form = this.querySelector('form');
            // We don't return here if form is missing, because we want listeners on the container 'this'
            // even if the form is injected later.

            // EVENT DELEGATION: Handle clicks (Remove & Qty Buttons)
            // Attached to 'this' (Custom Element) so it persists across innerHTML replacements
            this.addEventListener('click', (e) => {
                const target = e.target;
                
                // 1. REMOVE BUTTON
                const removeBtn = target.closest('.remove');
                if (removeBtn) {
                    e.preventDefault();
                    // Stop propagation to prevent any other listeners (like legacy ones) from firing if needed,
                    // but usually preventing default is enough.
                    const item = removeBtn.closest('[data-js-cart-item]');
                    if (item) this.updateCartQty(item, 0);
                    return;
                }
            });

            // EVENT DELEGATION: Handle Input Change
            this.addEventListener('input', debounce((e) => {
                const target = e.target;
                if (target.matches('.qty')) {
                    e.preventDefault();
                    const item = target.closest('[data-js-cart-item]');
                    if (item) this.updateCartQty(item, parseInt(target.value));
                }
            }, 500));
            
            // Initial setup for static elements
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){
            // Update the form reference as it might have been replaced
            this.form = this.querySelector('form');
            
            if(!this.form) return;

            this.querySelectorAll('[data-js-cart-item]').forEach(item=>{
				const remove = item.querySelector('.remove');
				if ( remove ) {
                    // Pre-emptively kill the href to avoid navigation if JS is slow
                    if(remove.getAttribute('href') && remove.getAttribute('href') !== 'javascript:void(0)') {
                        remove.dataset.href = remove.getAttribute('href');
					    remove.setAttribute('href', 'javascript:void(0)');
                    }
				}
			});
		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			// Enforcement quantità minima: se qty > 0 ma sotto il minimo, forza al minimo
			const qtyInput = item.querySelector('.qty');
			const itemMinQty = qtyInput && qtyInput.hasAttribute('data-min-qty') ? parseInt(qtyInput.getAttribute('data-min-qty')) : 1;
			if (newQty > 0 && newQty < itemMinQty) {
				newQty = itemMinQty;
				if (qtyInput) qtyInput.value = itemMinQty;
				if (window.nhToast) window.nhToast('⚠️ Quantità minima per questo prodotto: ' + itemMinQty + ' pz', 'error');
			}

            // USE KEY INSTEAD OF LINE INDEX (More Robust)
			const body = JSON.stringify({
				id: item.dataset.id, // Uses item key
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						
						let errorMsg = '';
						if ( typeof response.description === 'string' ) {
							errorMsg = response.description;
						} else if ( response.message ) {
							errorMsg = response.message;
						}

						// Traduzione stock limite in italiano leggibile
						// Shopify: "You can only add X of ... to the cart"
						if (errorMsg) {
							const stockMatch = errorMsg.match(/only\s+(?:add\s+)?(\d+)/i);
							if (stockMatch) {
								errorMsg = "⚠️ Disponibilità limitata: puoi aggiungere al massimo " + stockMatch[1] + " unità di questo prodotto.";
							}
						}

						if ( window.nhToast && errorMsg ) {
							window.nhToast(errorMsg, 'error');
						} else {
							// Fallback legacy se nhToast non esiste
							alert = document.createElement('span');
							alert.classList.add('alert', 'alert--error');
							alert.innerHTML = errorMsg;
						}
					}

					// CHECK SILENZIOSO: Shopify a volte tronca la qty senza errore 422
					// Confronta la quantità richiesta con quella effettiva nel carrello
					if (response.items && newQty > 0) {
						const itemKey = item.dataset.id;
						const updatedItem = response.items.find(i => i.key === itemKey);
						if (updatedItem && updatedItem.quantity < newQty) {
							const maxAvail = updatedItem.quantity;
							if (window.nhToast) {
								window.nhToast('⚠️ Disponibilità limitata: massimo ' + maxAvail + ' unità disponibili per questo prodotto.', 'error');
							}
						}
					}

					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const newCartForm = sectionInnerHTML.getElementById('AjaxCartForm');
					const newSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');

					if ( newCartForm ) {
						const cartItems = document.getElementById('AjaxCartForm');
						if ( cartItems ) {
							cartItems.innerHTML = newCartForm.innerHTML;
							if ( typeof cartItems.ajaxifyCartItems === 'function' ) {
								cartItems.ajaxifyCartItems();
							}

							const countElm = cartItems.querySelector('[data-cart-count]');
							const totalElm = cartItems.querySelector('[data-cart-total]');

							document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
								if ( countElm ) elm.textContent = countElm.textContent;
							});
							document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
								if ( totalElm ) elm.textContent = totalElm.textContent;
							});
						}
					}

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					if ( newSubtotal ) {
						const subtotalElm = document.getElementById('AjaxCartSubtotal');
						if ( subtotalElm ) {
							subtotalElm.innerHTML = newSubtotal.innerHTML;
						}
					}
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.error('Cart Update Error:', e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 250);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const newCartForm = sectionInnerHTML.getElementById('AjaxCartForm');
			const newSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');

			if ( newCartForm ) {
				const cartItems = document.getElementById('AjaxCartForm');
				if ( cartItems ) {
					cartItems.innerHTML = newCartForm.innerHTML;
					if ( typeof cartItems.ajaxifyCartItems === 'function' ) {
						cartItems.ajaxifyCartItems();
					}

					const countElm = cartItems.querySelector('[data-cart-count]');
					const totalElm = cartItems.querySelector('[data-cart-total]');

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						if ( countElm ) elm.textContent = countElm.textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						if ( totalElm ) elm.textContent = totalElm.textContent;
					});
				}
			}
			
			if ( newSubtotal ) {
				const currentSubtotal = document.getElementById('AjaxCartSubtotal');
				if ( currentSubtotal ) {
					currentSubtotal.innerHTML = newSubtotal.innerHTML;
				}
			}

			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}